export default __webpack_public_path__ + "static/media/hera_TN.6c9dacac.png";